module.exports = __webpack_public_path__ + "img/c17.6f48bfdc.png";